import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-unsplash', 'IconBrandUnsplash', [
  ['path', { d: 'M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z', key: 'svg-0' }],
]);
